<div class="header_search">
  <div class="title-page">
    <h3>Obras</h3>
  </div>
  <div class="content_search">
    <div class="new-project btn-new">
      <a routerLink="/qrobras/obra/adicionar" [queryParams]="{'pf_prt_issue_id': idEntrega}" class="btn btn-primary" type="btn" *ngIf="canCreatWork">Nova obra</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Título</th>
          <th>Órgão</th>
          <th>Municípios</th>
          <th class="text-center">Atualização</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of obrasList">
          <tr>
            <td class="title">{{item?.id}}</td>
            <td><span class="title-span">{{item?.title}}</span></td>
            <td>{{item?.agency_acron}}</td>
            <td>{{item?.city_names}}</td>
            <td class="text-center">
              <div class="m-b-xs">{{item?.ctr_usu_atu_name}}</div>
              {{item?.ctr_dth_atu}}
            </td>
            <td>
              <div class="btn-icon">
                <a [routerLink]="['/qrobras/obra/', item.id]" class="icon-table">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!obrasList?.length" class="border-b-radius">
          <td colspan="6" class="text-center">Nenhuma Obra Cadastrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>